import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import useStyles from "../../styles";
import CobeeTextField from "../../../../../CobeeTextField";

export default function RowPrivateUse({
  privateUsePercentage,
  setPrivateUsePercentage,
}: {
  privateUsePercentage: string | number;
  setPrivateUsePercentage(e: any): void;
}): JSX.Element {
  const { secondColumn, fieldRowSpacing, inputLabel } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("common-messages.private-use")}:
        </Typography>
        <Typography variant="body2">
          {t("common-messages.private-use-message")}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        container
        alignItems="center"
        className={`${secondColumn} ${fieldRowSpacing}`}
      >
        <Grid item xs={4}>
          <CobeeTextField
            styleType="default"
            variant="outlined"
            type="number"
            min={0}
            max={100}
            step="1"
            minWidth="100%"
            value={privateUsePercentage}
            onChange={(e) => setPrivateUsePercentage(e.target.value)}
          />
        </Grid>
        <Grid item xs={8}>
          <Typography variant="body2" className={inputLabel}>
            %
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
